export default __webpack_public_path__ + "static/safari.eec5944a31c3a799a05383e00dd1c99f.png";